import { ContributionTypes, Gift, PaymentStatus } from "../../FirestoreConverters"
import PaymentStatusIcon from "../General/PaymentStatusIcon";
import Tooltip from "../General/Tooltip";
import JOTLogoIconOlive from "../Icons/JOTLogoIconOlive.png"

type ContributionCardProps = {
  contribution: Gift;
  showMessages?: boolean;
  showAmounts?: boolean
}

const GiftingContributionCard = ({
  contribution: {
    giftAmount,
    message,
    type,
    cardholderLName,
    cardholderFName,
    giftedAt,
    status,
    treesAdded,
  },
  showAmounts,
  showMessages
}: ContributionCardProps) => {
return <div>
  <div className="flex px-4 py-2">
    <div className="flex-initial w-8/12">
      <p>
        <span className="font-bold">
          {type === ContributionTypes.REDEEM ?
            "You"
            :
            `${cardholderFName} ${cardholderLName}`
          }
        </span>
        {type === ContributionTypes.REDEEM ?
          " withdrew "
          :
          " contributed "
        }
      </p>
      <p className="text-xs space-x-2">
        <span>{giftedAt.toDate().toLocaleDateString()}</span>
        {treesAdded !== undefined && treesAdded > 0 ?
          <span>
            <Tooltip text={`${treesAdded} Trees donated to JUST ONE Tree`}>
              <img src={JOTLogoIconOlive} alt="JUST ONE Tree Icon" className="w-3 inline-block" /> x {treesAdded}
            </Tooltip>
          </span>
        : null}
     </p>
    </div>
    <div className="flex-none w-3/12 text-right my-auto text-my-orange md:text-2xl font-bold">
      {type === ContributionTypes.REDEEM && giftAmount < 0 ?
        `- £${(giftAmount * -1).toFixed(2)}`
      :
        showAmounts === true ? `£${giftAmount.toFixed(2)}` : "£??.??"
      }
    </div>
    <div className="flex-none w-1/12 text-right my-auto">
      <PaymentStatusIcon status={status as PaymentStatus} />
    </div>
  </div>

  {showMessages === true && type !== ContributionTypes.REDEEM && message !== undefined && message.length > 0 ?
    <div className="italic text-left break-words px-4 text-sm">
      <span className={`${!showMessages ? "hidden" : ""}`}>
        {/* <span className="text-2xl">&quot;</span> */}
          {message}
        {/* <span className="text-2xl">&quot;</span> */}
      </span>
    </div>
  : null}
</div>
}

export default GiftingContributionCard